(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var D = document.querySelector('[data-drawer]');
  var O = document.querySelector('[data-ov]');
  var T = document.querySelector('[data-toast]');
  var S = D ? D.dataset : {};
  function money(c) { return '\u20ac' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function toast(m) { if (!T) return; T.textContent = m; T.classList.add('show'); clearTimeout(toast.t); toast.t = setTimeout(function () { T.classList.remove('show'); }, 2800); }
  function openD() { if (!D) return false; D.classList.add('open'); O.classList.add('open'); return true; }
  function closeD() { if (D) D.classList.remove('open'); if (O) O.classList.remove('open'); }
  function render(c) {
    document.querySelectorAll('[data-count]').forEach(function (e) { e.textContent = c.item_count; });
    if (!D) return;
    var b = D.querySelector('[data-lines]');
    if (!c.items.length) {
      b.innerHTML = '<p class="mono" style="font-size:12px;color:rgba(8,32,58,.7)">' + esc(S.empty) + '</p>';
    } else {
      b.innerHTML = c.items.map(function (i) {
        var vt = i.variant_title && i.variant_title !== 'Default Title' ? ' \u00b7 ' + esc(i.variant_title) : '';
        return '<div class="dl"><a class="ri" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '') + '</a>' +
          '<a class="n" href="' + esc(i.url) + '">' + esc(i.product_title) + '<small>' + i.quantity + ' \u00d7 ' + money(i.final_price) + vt + '</small></a>' +
          '<div class="q"><button type="button" data-chg="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '" aria-label="-">\u2212</button>' +
          '<button type="button" data-chg="' + esc(i.key) + '" data-q="' + (i.quantity + 1) + '" aria-label="+">+</button></div>' +
          '<span class="lt">' + money(i.final_line_price) + '</span></div>';
      }).join('');
    }
    D.querySelector('[data-total]').textContent = money(c.total_price);
    var go = D.querySelector('[data-go]');
    if (c.items.length) go.removeAttribute('disabled'); else go.setAttribute('disabled', '');
  }
  function load() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.hasAttribute('data-ajax')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) { toast((item.product_title || '') + ' \u2014 ' + S.added); return load(); })
      .then(openD)
      .catch(function (err) { toast((err && err.description) || S.error); })
      .then(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    var oc = t.closest('[data-open-cart]');
    if (oc) { if (openD()) { e.preventDefault(); load(); } return; }
    if (t.closest('[data-close]')) { closeD(); return; }
    if (t.closest('[data-go]')) { window.location.href = root + 'checkout'; return; }
    var ch = t.closest('[data-chg]');
    if (ch) {
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: ch.dataset.chg, quantity: +ch.dataset.q }) }).then(function (r) { return r.json(); }).then(render);
      return;
    }
    if (t.closest('[data-burger]')) { var m = document.querySelector('[data-mnav]'); if (m) m.classList.toggle('open'); return; }
    var st = t.closest('[data-step]');
    if (st) { var i = st.parentNode.querySelector('input'); var min = i.hasAttribute('min') ? +i.getAttribute('min') : 1; i.value = Math.max(min, (+i.value || 0) + (+st.dataset.step)); return; }
    var fc = t.closest('[data-filter]');
    if (fc) {
      var v = fc.dataset.filter, n = 0;
      document.querySelectorAll('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === fc ? 'true' : 'false'); });
      document.querySelectorAll('[data-s]').forEach(function (c) { var show = v === 'all' || c.dataset.s === v; c.style.display = show ? '' : 'none'; if (show) n++; });
      var mt = document.querySelector('[data-meta-n]'); if (mt) mt.textContent = n;
      return;
    }
    var th = t.closest('[data-thumb]');
    if (th) { var main = document.querySelector('[data-main-img]'); if (main) main.src = th.dataset.thumb; document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === th ? 'true' : 'false'); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });
})();
